<app-data-visualization [assessment]="assessment"
                        [globalId]="globalId"
                        [hideLabels]="hideLabels" />
